module.exports = __webpack_public_path__ + "static/people_img28-106ef1c8e9e82046093e9da3d797da87.png";